import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  constructor() {}

  async initializeMapView(container: HTMLDivElement) {
  const [MapModule, SceneViewModule, GraphicsLayerModule] = await Promise.all([
    import('@arcgis/core/Map'),
    import('@arcgis/core/views/SceneView'),
    import('@arcgis/core/layers/GraphicsLayer'),
  ]);

  const graphicsLayer = new GraphicsLayerModule.default({
    elevationInfo: { mode: 'on-the-ground' },
    title: 'Sketch GraphicsLayer',
  });

  const map = new MapModule.default({
    basemap: 'hybrid',
    ground: 'world-elevation',
    layers: [graphicsLayer],
  });

  const view = new SceneViewModule.default({
    container,
    map,
    camera: {
      position: { longitude: -100.54688, latitude: 35.07323, z: 15000000 },
    },
    qualityProfile: 'high',
  });

  return { view, graphicsLayer };
}


  async setupSketchViewModel(view: __esri.SceneView, graphicsLayer: __esri.GraphicsLayer) {
  const SketchViewModelModule = await import('@arcgis/core/widgets/Sketch/SketchViewModel');

  return new SketchViewModelModule.default({
    layer: graphicsLayer,
    view,
    polygonSymbol: {
      type: 'simple-fill',
      color: 'rgba(255,255,255,0.3)',
      outline: { color: '#007DA3', width: 3 },
    },
    snappingOptions: { enabled: false, featureSources: [{ layer: graphicsLayer }] },
    tooltipOptions: { enabled: true },
    labelOptions: { enabled: true },
    defaultUpdateOptions: { tool: 'reshape' },
  });
}
}
